import * as React from "react";
import { Container, Table, Badge } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";

const maxVisiblePages = 5;

export default function Transactions({ accountInfo }) {
  const [transactions, setTransactions] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = `https://smeshi-api.com/account/${
          accountInfo.address
        }/transactions?sort=desc&limit=20&offset=${(currentPage - 1) * 20}`;
        const response = await fetch(apiUrl);
        const total = accountInfo.numberOfTransactions;
        const result = await response.json();

        setTransactions(() => setTransactions(result));
        setTotalPages(Math.ceil(total / 20));
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage, accountInfo]);

  const displayRewards = () => {
    if (transactions)
      return transactions.map((t, index) => {
        return (
          <tr key={t.id}>
            <td>{`${t.id.slice(
              0,
              4
            )}...${t.id.slice(-4)}`}</td>
            <td>{t.status === 0 ? "Completed" : "Error"}</td>
            <td>{t.fee}</td>
            <td>{(t.amount / 1000000000).toFixed(2)} SMH</td>
            <td>{accountInfo.address === t.principalAccount ? <Badge bg="danger"> {t.method} Out</Badge> : <Badge bg="success">{t.method} In</Badge>}</td>
            <td>{t.layer}</td>
            <td>{`${t.principalAccount.slice(
              0,
              4
            )}...${t.principalAccount.slice(-4)}`}</td>
            <td>{`${t.receiverAccount.slice(0, 4)}...${t.receiverAccount.slice(
              -4
            )}`}</td>
            <td>{new Date(t.timestamp * 1000).toLocaleString()}</td>
          </tr>
        );
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(
      1,
      currentPage - Math.floor(maxVisiblePages / 2)
    );
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };
  return (
    <Container>
      <Table striped bordered hover variant="dark" size="sm">
        <thead>
          <tr>
            <th>Transaction ID</th>
            <th>Status</th>
            <th>Fee</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Layer</th>
            <th>Sender</th>
            <th>Receiver</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>{displayRewards()}</tbody>
      </Table>
      <Pagination>
        <Pagination.First
          onClick={handleFirstPage}
          disabled={currentPage === 1}
        />
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {renderPageNumbers()}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
        <Pagination.Last
          onClick={handleLastPage}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </Container>
  );
}
